import { Component, OnInit } from '@angular/core';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.css']
})
export class LanguagesComponent implements OnInit {
  private currentLanguage: string;


  constructor(private translate: TranslateService) {
        translate.setDefaultLang('en');
        this.setTranslation('en');

   };

  ngOnInit() {
  }

  setTranslation(language) {
    this.translate.use(language);
    this.currentLanguage = language;
  }

  isSelected(language) {
    return this.currentLanguage === language;
  }

}



// WEBPACK FOOTER //
// ./src/app/header/languages/languages.component.ts